import { OutlinedInput, OutlinedInputProps } from "../outlined-input";
import EyeIcon from "@mui/icons-material/Visibility";
import EyeOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import { useState } from "react";

export const PasswordInput = <T,>(props: OutlinedInputProps<T>) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  const decorator = (
    <IconButton
      onClick={toggleShowPassword}
      edge="end"
      size="small"
      sx={{ visibility: props.disabled ? "hidden" : "visible", opacity: 0.5 }}
    >
      {showPassword ? <EyeOffIcon /> : <EyeIcon />}
    </IconButton>
  );

  return (
    <OutlinedInput
      {...props}
      type={showPassword ? "text" : "password"}
      endDecorator={decorator}
    />
  );
};
